<section class="card">
  <div class="widget-container">
    <h3>Pending FOC Date ({{ total || '...' }})</h3>

    @if (loading) {
      <div class="loading-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    } @else {
      <div class="chart">
        <canvas
          baseChart
          id="pending-foc-chart"
          height="220px"
          [data]="barChartData"
          [options]="barChartOptions"
          [plugins]="barChartPlugins"
          [type]="barChartType">
        </canvas>
      </div>
    }
  </div>
</section>
